const OfferStatusIds = {
    PUBLISH: "PUBLISH",
    SUSPENDED: "SUSPENDED",
    CLOSED: "CLOSED",
    DRAFT: "DRAFT",
    TO_VALIDATE: "TO_VALIDATE"
};

export default OfferStatusIds;
